import { z } from '@betty/toolkit/api';

export const InstantWheelSectorSchema = z.object({
  id: z.number(),
  winAmount: z.number(),
  targetType: z.literal('Coins'),
  isSpecialSector: z.boolean(),
});

export const InstantWheelSectorsSchema = z.object({
  balance: z.number(),
  dailyWheelSectors: z.array(InstantWheelSectorSchema),
});

export const InstantWheelSpinsCountSchema = z.object({
  remainingSpinsCount: z.number(),
});

export const InstantWheelRewardSchema = InstantWheelSectorSchema.merge(
  z.object({
    balance: z.number(),
    remainingSpins: z.number(),
  }),
);
